import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { routes } from '../../constantes/routes'
import { tasksActions } from '../../actions/tasksActions'
import { phasesActions } from '../../actions/phasesActions'
import { eventsActions } from '../../actions/eventsActions'
import { businessunitsActions } from '../../actions/businessunitsActions'
import { usersActions } from '../../actions/usersActions'
import { eventosActions } from '../../actions/eventosActions'
import { contactsActions } from '../../actions/contactsActions'
import { hospitalsActions } from '../../actions/hospitalsActions'
import { specialtiesActions } from '../../actions/specialtiesActions'
import TaskHistory from './tasks/TaskHistory'
import TasksModal from './tasks/TasksModal'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../utils/swalAlert'
import { swalTitle } from '../../constantes/swalTitle'
import { onSubmitText } from '../../constantes/onSubmitText'
import PlusBtn from '../buttons/PlusBtn'
import Search from '../common/Search'
import Header from '../header/Header'
import _ from 'lodash'
import { swalMssgs } from '../../constantes/swalMssgs'
import { formatDateForInput } from '../../utils/date'
import './tasks.scss'
import { entitiesExport } from '../../constantes/exportEndpoints'
import { exportActions } from '../../actions/exportActions'
import {downloadCSV } from '../../utils/downloadCSV'

const ManagementContainer = () => {
  // Leer parámetros de URL para filtrar por evento
  const urlParams = new URLSearchParams(window.location.search)
  const eventoIdFromUrl = urlParams.get('evento')

  const history = useHistory()

  const allUsers = useSelector((state) => state.users || [])
  const userProfile = useSelector((state) => state.userProfile || {})
  const phases = useSelector((state) => state.phases || [])
  const contacts = useSelector((state) => state.contacts || [])
  const events = useSelector((state) => state.events || [])
  const businessunits = useSelector((state) => state.businessunits || [])
  const eventos = useSelector((state) => state.eventos || [])
  const hospitals = useSelector((state) => state.hospitals || [])
  const specialties = useSelector((state) => state.specialties || [])

  const [userId, setUserId] = useState(0) // Inicializar en 0 para "Mis tareas"
  const [eventId, setEventId] = useState(eventoIdFromUrl ? eventoIdFromUrl : 0) // Filtrar por evento (0 = todos)
  const [search, setSearch] = useState(null)
  const [items, setItems] = useState([])
  const [allTasks, setAllTasks] = useState([]) // Todas las tareas sin filtrar

  // Estado para el modal de tareas (crear y editar)
  const [newTask, setNewTask] = useState({
    id_Usuario: '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    asunto: '',
    fecha: '',
    descripcion: '',
    isVerCaledario: false,
    id_Evento: '',
    id_NegocioUnidades: [],
    especialidades: '',
    hospitales: '',
  })
  const [taskModalIsOpen, setTaskModalIsOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [taskToEdit, setTaskToEdit] = useState(null)

  const dispatch = useDispatch()
  const getAllTasks = (userIdFilter) =>
    dispatch(tasksActions.getAllTasks(userIdFilter || 0, eventId))
  const createTask = (task) => dispatch(tasksActions.newTask(task))
  const updateTask = (task) => dispatch(tasksActions.updateTask(task))
  const getAllPhases = () => dispatch(phasesActions.getAllPhases())
  const getAllEvents = () => dispatch(eventsActions.getAllEvents())
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllUsers = () => dispatch(usersActions.getAllUsers())
  const getAllEventos = () => dispatch(eventosActions.getAllEventos())
  const getAllContacts = () => dispatch(contactsActions.getAllContacts())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())

  const deleteTask = (idTask) => dispatch(tasksActions.deleteTask(idTask))

  useEffect(() => {
    retrieveTasks()
    getAllPhases()
    getAllEvents()
    getAllBusinessUnits()
    getAllContacts()
    getAllEventos() // Cargar eventos para poder acceder a sus unidades de negocio
    getAllHospitals()
    getAllSpecialties()
    // Verificar si necesitamos cargar usuarios
    if (!allUsers || allUsers.length === 0) {
      getAllUsers()
    }
  }, [])

  // Verificar si necesitamos cargar usuarios cuando el usuario tenga permisos
  useEffect(() => {
    if (
      userProfile &&
      userProfile.roles &&
      userProfile.roles.isTareasFiltroVer
    ) {
      if (!allUsers || allUsers.length === 0) {
        getAllUsers()
      }
    }
  }, [allUsers, userProfile])

  useEffect(() => {
    if (userProfile && userProfile.id_Usuario) {
      retrieveTasks()
    }
  }, [userId, userProfile, eventId])

  // Aplicar filtro de búsqueda cuando cambie el search
  useEffect(() => {
    if (allTasks.length > 0) {
      filterTasksBySearch(allTasks, search)
    }
  }, [search, allTasks])

  const retrieveTasks = async () => {
    try {
      // Determinar qué userId usar para la llamada al backend
      const userIdForBackend =
        userId === 0 && userProfile && userProfile.id_Usuario
          ? userProfile.id_Usuario
          : userId

      const response = await getAllTasks(userIdForBackend)
      if (response && response.payload) {
        setAllTasks(response.payload) // Guardar todas las tareas
        filterTasksBySearch(response.payload, search) // Solo aplicar filtro de búsqueda
      }
    } catch (error) {
      setAllTasks([])
      setItems([])
    }
  }

  const filterTasksBySearch = (tasks, searchTerm) => {
    // Filtrar por búsqueda
    const filteredTasks = (() => {
      if (searchTerm && searchTerm.trim() !== '') {
        const searchLower = searchTerm.toLowerCase().trim()
        return tasks.filter((task) => {
          return (
            (task.asunto && task.asunto.toLowerCase().includes(searchLower)) ||
            (task.descripcion &&
              task.descripcion.toLowerCase().includes(searchLower)) ||
            (task.contacto &&
              task.contacto.toLowerCase().includes(searchLower)) ||
            (task.tipoFase &&
              task.tipoFase.toLowerCase().includes(searchLower)) ||
            (task.tipoAsunto &&
              task.tipoAsunto.toLowerCase().includes(searchLower)) ||
            (task.evento && task.evento.toLowerCase().includes(searchLower)) ||
            (task.usuario &&
              task.usuario.toLowerCase().includes(searchLower)) ||
            (task.hospitales &&
              task.hospitales.toLowerCase().includes(searchLower)) ||
            (task.especialidades &&
              task.especialidades.toLowerCase().includes(searchLower))
          )
        })
      }
      return tasks
    })()
    setItems(filteredTasks)
  }

  const openNewTaskModal = () => {
    // Si hay un evento preseleccionado, buscar sus unidades de negocio
    const preselectedBusinessUnits = (() => {
      if (eventId > 0) {
        const selectedEvento = eventos.find(
          (evento) => evento.id_Evento === parseInt(eventId),
        )
        if (selectedEvento && selectedEvento.id_NegocioUnidades) {
          return Array.isArray(selectedEvento.id_NegocioUnidades)
            ? selectedEvento.id_NegocioUnidades
            : [selectedEvento.id_NegocioUnidades]
        }
      }
      return []
    })()

    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: '',
      descripcion: '',
      isVerCaledario: false,
      id_Evento: eventId > 0 ? eventId.toString() : '', // Pre-seleccionar evento si está filtrado
      id_NegocioUnidades: preselectedBusinessUnits, // Pre-seleccionar unidades de negocio del evento
      especialidades: '',
      hospitales: '',
    })
    setIsEditMode(false)
    setTaskToEdit(null)
    setTaskModalIsOpen(true)
  }

  const openEditTaskModal = (task) => {
    setNewTask({
      id_Crm: task.id_Crm || '',
      id_Usuario: task.id_Usuario || '',
      id_Contacto: task.id_Contacto || '',
      id_TipoFase: task.id_TipoFase || '',
      id_TipoAsunto: task.id_TipoAsunto || '',
      id_Evento: task.id_Evento || '',
      asunto: task.asunto || '',
      fecha: formatDateForInput(task.fecha || ''),
      descripcion: task.descripcion || '',
      isVerCaledario: task.isVerCaledario || false,
      id_NegocioUnidades: task.id_NegocioUnidades || [],
      especialidades: task.especialidades || '',
      hospitales: task.hospitales || '',
    })
    setIsEditMode(true)
    setTaskToEdit(task)
    setTaskModalIsOpen(true)
  }

  const closeTaskModal = () => {
    setTaskModalIsOpen(false)
    setIsEditMode(false)
    setTaskToEdit(null)
    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: '',
      descripcion: '',
      isVerCaledario: false,
      id_Evento: eventId > 0 ? eventId.toString() : '', // Mantener evento seleccionado
      id_NegocioUnidades: [],
      especialidades: '',
      hospitales: '',
    })
  }

  const handleChangeNewTask = (eventOrArray) => {
    // Si recibimos un array de eventos, actualizamos todos los campos
    if (Array.isArray(eventOrArray)) {
      let updatedTask = { ...newTask }
      eventOrArray.forEach((event) => {
        const value =
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
        const name = event.target.name

        // No permitir cambios en las unidades de negocio ya que son solo de lectura
        if (name === 'id_NegocioUnidades') {
          return
        }

        updatedTask = { ...updatedTask, [name]: value }
      })
      setNewTask(updatedTask)
      return
    }

    // Caso normal: un solo evento
    const value =
      eventOrArray.target.type === 'checkbox'
        ? eventOrArray.target.checked
        : eventOrArray.target.value
    const name = eventOrArray.target.name

    if (name === 'id_NegocioUnidades') {
      return
    }

    setNewTask({ ...newTask, [name]: value })
  }

  const handleSubmitNewTask = async (event) => {
    event.preventDefault()
    try {
      if (isEditMode) {
        const response = await updateTask(newTask)
        if (response && response.type && response.type.includes('SUCCESS')) {
          swalSuccessGeneral(
            'Actualizado Correctamente',
            swalMssgs.UPDATE_SUCCES,
          )
          closeTaskModal()
          await retrieveTasks() // Recargar la lista de tareas
        } else {
          swalAlertError('Error al actualizar el lead')
        }
      } else {
        const response = await createTask(newTask)
        if (response && response.type && response.type.includes('SUCCESS')) {
          swalSuccessGeneral('Creado Correctamente', swalMssgs.NEW_SUCCES)
          closeTaskModal()
          await retrieveTasks() // Recargar la lista de tareas
        } else {
          swalAlertError('Error al crear el lead')
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data
          : isEditMode
          ? 'Error al actualizar el lead'
          : 'Error al crear el lead'
      swalAlertError(errorMessage)
    }
  }

  const validateFormNewTask = () => {
    return (
      newTask.id_Usuario &&
      newTask.id_Usuario.toString().trim() !== '' &&
      newTask.id_TipoAsunto &&
      newTask.id_TipoAsunto.toString().trim() !== '' &&
      newTask.asunto &&
      newTask.asunto.trim() !== '' &&
      newTask.id_TipoFase &&
      newTask.id_TipoFase.toString().trim() !== '' &&
      newTask.id_Contacto &&
      newTask.id_Contacto.toString().trim() !== '' &&
      newTask.fecha &&
      newTask.fecha.trim() !== '' &&
      newTask.descripcion &&
      newTask.descripcion.trim() !== '' &&
      newTask.hospitales.trim() !== '' &&
      newTask.especialidades.trim() !== ''
    )
    // Las unidades de negocio no se validan porque son solo de lectura
  }

  const handleRemove = async (idTask) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el lead?',
      )
      if (alert.isConfirmed) {
        await deleteTask(idTask)
        swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
        await retrieveTasks() // Recargar la lista después de eliminar
      }
    } catch (error) {
      swalAlertError(error)
    }
  }

  // Actualizar el id_Usuario seleccionado
  const handleChangeOption = (event) => {
    const value = event.target.value === '0' ? 0 : parseInt(event.target.value)
    setUserId(value)
  }

  const onChangeSearch = (value) => {
    const searchValue = value.trim() === '' ? null : value
    setSearch(searchValue)
  }

  const toEditTask = async (id) => {
    const task = items.find((task) => task.id_Crm.toString() === id.toString())
    if (task) {
      openEditTaskModal(task)
    }
  }

  const toCalendar = () => {
    history.push(routes.CALENDAR)
  }
  const toMain = () => {
    history.push(routes.MAIN)
  }

  const toEventos = () => {
    history.push(routes.EVENTOS)
  }

  // Buscar el evento actual si se está filtrando
  const currentEvent =
    eventId > 0
      ? eventos.find((evento) => evento.id_Evento === parseInt(eventId))
      : null

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.LEADS),
    )
    downloadCSV("Leads", response)
  }

  const usuariosFiltradas = _.orderBy(allUsers, ['nombre'], ['asc'])
  return (
    <>
      <div className='history-wrap'>
        <div className='products'>
          <Header
            text={
              currentEvent
                ? `Leads del Evento: ${currentEvent.nombre}`
                : 'Gestión de Leads'
            }
            route={currentEvent ? toEventos : toMain}
            backBtn={true}
          />
          {/* Mostrar información adicional del evento si se está filtrando */}
          {currentEvent && (
            <div className='event-filter-info'>
              <h5>📅 Evento Seleccionado: {currentEvent.nombre}</h5>
              <p>
                📍 {currentEvent.ubicacion} | 📅 {currentEvent.fechaInicio} -{' '}
                {currentEvent.fechaFinal}
              </p>
              <button
                onClick={() => {
                  // Limpiar filtro de evento y volver a la gestión normal
                  history.push(routes.MANAGEMENT)
                  setEventId(0)
                }}
              >
                🗑️ Limpiar filtro de evento
              </button>
            </div>
          )}
          <div className='filter__wrap mb-80'>
            {userProfile &&
            userProfile.roles &&
            userProfile.roles.isTareasFiltroVer ? (
              <div>
                <div className='sort-role__wrap'>
                  <h4 className='filter__title'>Filtrar por</h4>
                  <select
                    className='select-filter'
                    value={userId}
                    onChange={handleChangeOption}
                  >
                    <option value={0} className='options-field'>
                      Mis Leads
                    </option>
                    {usuariosFiltradas.length > 0
                      ? usuariosFiltradas.map((user) => (
                          <option
                            key={user.id_Usuario}
                            value={user.id_Usuario}
                            className='options-field'
                          >
                            {user.nombre}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            ) : null}
            <Search onChangeSearch={onChangeSearch} placeholder='Buscar...' />

            <div className='add__action__rigth__side'>
              <button
                style={{ cursor: 'pointer' }}
                onClick={toCalendar}
                className='btn-landing'
              >
                Ver agenda
              </button>
              <button
                onClick={handleExportCSV}
                className='btn-landing'
                style={{ cursor: 'pointer', marginRight: '15px' }}
              >
                📊 Exportar CSV
              </button>
              <>
                <button className='action-button' onClick={openNewTaskModal}>
                  <PlusBtn />
                  <span>Nuevo lead</span>
                </button>
              </>
            </div>
          </div>

          <TaskHistory
            allUserTasks={items}
            handleRemove={handleRemove}
            toEditTask={toEditTask}
            userProfile={userProfile}
          />
        </div>
      </div>

      <TasksModal
        modalIsOpen={taskModalIsOpen}
        closeModal={closeTaskModal}
        inputs={newTask}
        handleChange={handleChangeNewTask}
        handleSubmit={handleSubmitNewTask}
        validateForm={validateFormNewTask}
        textBtn={isEditMode ? onSubmitText.Guardar : onSubmitText.Crear}
        phases={phases}
        contacts={contacts}
        events={events}
        businessunits={businessunits}
        hospitals={hospitals}
        specialties={specialties}
        isEdit={isEditMode}
        taskToEdit={taskToEdit}
        onTaskUpdated={retrieveTasks}
        disableEventField={currentEvent ? true : false}
      />
    </>
  )
}

export default withRouter(ManagementContainer)
